import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = ({ endpoints, activeEndpoint, onSelect, mobileOpen, onMobileClose }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleSelect = (id) => {
    onSelect(id);
    if (onMobileClose) onMobileClose();
  };

  // Icon mapping for sidebar items
  const getIcon = (id) => {
    const icons = {
      users: '👥',
      addresses: '📍',
      alerts: '🔔',
      articles: '📰',
      daily_keyword_facebook: '📘',
      daily_keyword_instagram: '📸',
      daily_keyword_threads: '🧵',
      daily_keyword_tiktoks: '🎵',
      daily_keyword_truths: '📢',
      truth_tags: '🏷️',
      instagram_posts: '📷',
      daily_keyword_tweets: '🐦',
      x_users: '✖️',
      tiktok_challenges: '🎯',
      companies: '🏢',
      company_addresses: '🏠',
      configurations: '⚙️',
      keywords: '🔑',
      permissions: '🔐',
      role_permissions: '🛡️',
      roles: '👔',
      user_addresses: '📬',
      user_alert: '📳',
      user_roles: '🎭',
    };
    return icons[id] || '📋';
  };

  return (
    <>
      {/* Mobile overlay */}
      <div
        className={`sidebar-mobile-overlay ${mobileOpen ? 'visible' : ''}`}
        onClick={onMobileClose}
      />

      <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <h3>{isCollapsed ? '☰' : 'Navigation'}</h3>
          <button className="collapse-btn" onClick={toggleSidebar}>
            {isCollapsed ? '▸' : '◂'}
          </button>
        </div>
        <ul className="sidebar-menu">
          {endpoints.map((endpoint) => (
            <li
              key={endpoint.id}
              className={`sidebar-item ${activeEndpoint === endpoint.id ? 'active' : ''}`}
              onClick={() => handleSelect(endpoint.id)}
            >
              <NavLink
                to={`/dashboard?tab=${endpoint.id}`}
                className="sidebar-link"
              >
                {isCollapsed ? (
                  <span title={endpoint.name}>{getIcon(endpoint.id)}</span>
                ) : (
                  <>
                    <span style={{ marginRight: '8px', fontSize: '0.9em' }}>{getIcon(endpoint.id)}</span>
                    {endpoint.name}
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
